
exports.pbkdf2 = require('./lib/async')

exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/pbkdf2/browser.js
// module id = ../../../../pbkdf2/browser.js
// module chunks = 4